console.log('Starting JS');
window._ = require('lodash');
window.Swal = require('sweetalert2');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': token.content
        }
    });
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

window.slugify = function (text) {
    return text.toString().toLowerCase()
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
        .replace(/\-\-+/g, '-')         // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '');            // Trim - from end of text
}

/**
 * npm packages
 */
require('jquery-form');
require('metismenu');
require('icheck');
require('jquery-slimscroll');
require('datatables');
require('datatables.net');
require('pdfmake/build/pdfmake.min');
require('pdfmake/build/vfs_fonts');
require('datatables.net-bs');
require('datatables.net-buttons');
require('datatables.net-buttons/js/buttons.print.min');
require('datatables.net-buttons/js/buttons.html5.min');
require('datatables.net-buttons-bs');
require('bootstrap-datepicker');
require('eonasdan-bootstrap-datetimepicker');
require('select2');
require('jquery-validation');
require('jquery-ui');
require('jquery-ui/ui/widgets/sortable');
require('bootstrap-slider');
window.moment = require('moment');
window.swal = require('sweetalert2');
window.toastr = require('toastr');
window.Ladda = require('ladda');

/**
 * Packages that are not available through npm
 */
require('./vendor/jquery.sparkline.min');

/**
 * Theme main scripts
 */
require('./homer');
